import { render, staticRenderFns } from "./SimulationModeBar.vue?vue&type=template&id=65536e52&scoped=true&"
import script from "./SimulationModeBar.vue?vue&type=script&lang=js&"
export * from "./SimulationModeBar.vue?vue&type=script&lang=js&"
import style0 from "./SimulationModeBar.vue?vue&type=style&index=0&id=65536e52&prod&lang=scss&scoped=true&"
import style1 from "./SimulationModeBar.vue?vue&type=style&index=1&id=65536e52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65536e52",
  null
  
)

/* custom blocks */
import block0 from "./SimulationModeBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports